module.exports = __webpack_public_path__ + "img/prestep-illustration-mobile.30569d5f.jpg";